import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import LanguageProvider from '../contexts/LanguageProvider';
import { AlertProvider } from '../contexts/AlertContext';
import LoginModal from '../components/Login/LoginModal';
import SiteDisclaimerModal from '../components/SiteDisclaimerModal';
import '../styles/Layout.css';

const Layout = () => {
  const [theme, setTheme] = React.useState('light');

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      setTheme(localStorage.getItem('theme') || 'light');
    }
  }, []);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    localStorage.setItem('theme', theme);
    document.body.setAttribute('data-bs-theme', theme);
    document.documentElement.setAttribute('data-bs-theme', theme);
  }, [theme]);

  return (
    <LanguageProvider>
      <div data-bs-theme={theme} className="app-shell">
        <Header switchTheme={setTheme} themeNow={theme} />

        <AlertProvider>
          <main className="main-content">
            <div className="page-container">
              <Outlet />
            </div>
          </main>
          <LoginModal />
        </AlertProvider>

        <SiteDisclaimerModal />
      </div>
    </LanguageProvider>
  );
};

export default Layout;
